import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: ActionBox = {
  ActionBoxID: null,
  TenantID: null,
  Title: '',
  Description: '',
  ButtonLabel: '',
  RedirectionUrl: '',
  imageUrl: '',
  ActionBoxCategoryID: null,
  UiPosition: null,
  StartDateUTC: '',
  EndDateUTC: '',
  ActionBoxCategory: {
    CategoryName: null
  },
  ImageID: null,
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Title: null,
    Description: null,
    CtaLabel: null
  },
  translations: {
    ActionBoxTranslationID: null,
    Title: null,
    Description: null,
    CtaLabel: null,
    LanguageCode: null
  }
}

export const actionBoxSlice = createSlice({
  name: 'actionBox',
  initialState,
  reducers: {
    setActionBox: (state, action: PayloadAction<ActionBox>) => {
      return action.payload
    },
    setActionBoxSelectedTranslations: (
      state,
      action: PayloadAction<SetActionBoxTranslationParams>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          ActionBoxTranslationID:
            action.payload.translations?.ActionBoxTranslationID ?? null,
          Title: action.payload.translations?.Title ?? null,
          Description: action.payload.translations?.Description ?? null,
          CtaLabel: action.payload.translations?.CtaLabel ?? null,
          LanguageCode: action.payload.selectedLanguage
        }
      }
    }
  }
})

export const { setActionBox, setActionBoxSelectedTranslations } =
  actionBoxSlice.actions

export const actionBoxReducer = actionBoxSlice.reducer
